import type { Form } from '../../../common/types/form';
import type { Setting } from '../../../common/types/settings';
import type { Transfer } from '../../../common/types/transfer';

const coreDataForm = (advisors: Setting[]): Form<Transfer> => {
  const advisorOptions = advisors.map((advisor) => advisor.value);

  return {
    key: 'transferData',
    fields: [
      {
        key: 'from',
        label: 'Von',
        fieldTypes: 'autocomplete',
        options: advisorOptions,
      },
      {
        key: 'to',
        label: 'An',
        fieldTypes: 'autocomplete',
        options: advisorOptions,
      },
      {
        key: 'appointmentDate',
        label: 'Termin',
        fieldTypes: 'date',
      },
      {
        key: 'appointmentTime',
        label: 'Zeit',
        fieldTypes: 'time',
      },
      {
        key: 'state',
        label: 'ist erledigt',
        fieldTypes: 'checkbox',
        breakRowAfterField: true,
      },
      {
        key: 'priority',
        label: 'Priorität',
        fieldTypes: 'select',
        options: [
          {
            label: 'niedrig',
            value: 'low',
          },
          {
            label: 'mittel',
            value: 'medium',
          },
          {
            label: 'hoch',
            value: 'high',
          },
        ],
      },
      {
        key: 'category',
        label: 'Kategorie',
        fieldTypes: 'select',
        options: [
          {
            label: 'Info',
            value: 'info',
          },
          {
            label: 'To-Do',
            value: 'to-do',
          },
        ],
      },
      {
        key: 'topic',
        label: 'Thema',
        fieldTypes: 'text',
        xsWidth: 12,
      },
      {
        key: 'note',
        label: 'Notiz',
        fieldTypes: 'richTextArea',
        rows: 8,
        xsWidth: 12,
      },
    ],
  };
};

export default coreDataForm;
